module.exports = __webpack_public_path__ + "img/paris_feature.28681cbf.jpg";